import { createSlice } from "@reduxjs/toolkit";

export const getBasketTotal = (basket) =>
  basket?.reduce((total, item) => total + item.price, 0);

export const userSlice = createSlice({
  name: "user",
  initialState: {
    basket: [],
    user: null,
  },
  reducers: {
    addItem: (state, action) => {
      console.log("additem in basket trigger");
      // Redux Toolkit allows us to write "mutating" logic in reducers. It
      // doesn't actually mutate the state because it uses the Immer library,
      // which detects changes to a "draft state" and produces a brand new
      // immutable state based off those changes
      state.basket = [...state.basket, action.payload.item];
    },
    removeItem: (state, action) => {
      console.log("Remove action", action, state.basket);
      const index = state.basket.findIndex(
        (basketItem) => basketItem.id === action.payload.id
      );
      let newBasket = [...state.basket];

      if (index >= 0) {
        newBasket.splice(index, 1);
      } else {
        console.warn(
          `Cant remove product (id: ${action.payload.id}) as its not in basket`
        );
      }
      state.basket = newBasket;
    },
    emptyBasket: (state) => {
      state.basket = [];
    },
    setUser: (state, action) => {
      console.log("user in reducer", action.payload);
      state.user = action.payload.username;
    },
    logout: (state) => {
      console.log("logout  trigger");
      state.user = null;
    },
  },
});

export const {
  setUser,
  logout,
  addItem,
  removeItem,
  emptyBasket,
} = userSlice.actions;

// The function below is called a thunk and allows us to perform async logic. It
// can be dispatched like a regular action: `dispatch(incrementAsync(10))`. This
// will call the thunk with the `dispatch` function as the first argument. Async
// code can then be executed and other actions can be dispatched

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state) => state.counter.value)`
export const selectUser = (state) => state;

export default userSlice.reducer;
